/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { PERMISSIONS } from "../../../../../../../../consts/api";
import { PrivilegesGuard } from "../../../../../../../../shared/PrivilegesGuard";
import { useContext } from "../../context";

export function Header() {
  const { appointment, onClose } = useContext();

  return (
    <div className="newPopupTitle">
      Out of office Details
      <PrivilegesGuard
        requiredPrivileges={[PERMISSIONS.appointments.manageAppointments]}
      >
        {moment(appointment.outOfOffice.date).isSameOrAfter(
          moment(),
          "day",
        ) && (
          <Link
            to={`/appointment/edit/${appointment.id}/${appointment.clinic.id}`}
            className="easy-link edit-event-detail-btn"
          >
            <i className="fa fa-pencil-alt"></i> Edit
          </Link>
        )}
      </PrivilegesGuard>
      <a className="popupClose" onClick={onClose}>
        <img alt="" src="/images/close.png" />
      </a>
    </div>
  );
}
